import React from 'react'
import styles from './HomePage.module.css'
import { Link } from 'react-router-dom'

const HomePage = props => {
  return (
    <section id="homepage" className={styles.HomePage}>
      <div className="container">
        <h1>Hangman</h1>
        <div className={styles.pic_container}>
          <div className={styles.hangman_pic} />
        </div>
        <div className={styles.options}>
          <div className={styles.play_option}>
            <Link to="/play"><h3>Play</h3></Link>
          </div>
          <div className={styles.stats_option}>
          <Link className={styles.stats} to="/stats"><h3>Stats</h3></Link>
          </div>
          <div className={styles.multiplayer_option}>
          <Link className={styles.multiplayer} to="/"><h3>Multiplayer</h3></Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomePage
